import { Theme } from '@mui/material/styles';

export const homeScreenStyles = (theme: Theme) => ({
  container: {
    width: '100vw',
    minHeight: '100vh',
    height: 'auto',
    direction: 'column',
    alignItems: 'center',
    alignContent: 'flex-start',
    justifyContent: 'center',
    m: 0,
    [theme.breakpoints.down('sm')]: { px: 2, alignItems: 'flex-start' }
  },
  button: {
    width: 'fit-content',
    mt: 3,
    mb: 8
  },
  termsConditions: { justifyContent: 'center', m: 0 },
  termsAndButton: {
    diplay: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('lg')]: { pt: 2 },
    [theme.breakpoints.up('xl')]: { pt: 2 }
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    textAlign: 'center',
    px: 3,
    pt: 4,
    [theme.breakpoints.up('md')]: { pt: 5 }
  },
  termsConditionsText: {
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: { flexDirection: 'column', pl: 1.5 }
  },
  link: {
    textDecoration: 'none',
    fontVariationSettings: "'wght' 400",
    [theme.breakpoints.up('sm')]: { pl: 0.5 }
  },
  countdownContainer: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.up('xl')]: { height: '610px', px: 14 },
    [theme.breakpoints.up('lg')]: { height: '410px', px: 10 },
    [theme.breakpoints.up('md')]: { height: '300px', px: 10 },
    [theme.breakpoints.up('sm')]: { height: '250px', px: 4 },
    [theme.breakpoints.down('sm')]: { pt: 0 }
  },
  itemCard: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: { height: '300px' }
  },
  titleContainer: { pt: 6, pb: 4 },
  subtitle: {
    fontVariationSettings: "'wght' 300"
  }
});
